import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row g-5 g-xl-8" }
const _hoisted_2 = { class: "col-xl-4" }
const _hoisted_3 = { class: "col-xl-8" }
const _hoisted_4 = { class: "row g-5 g-xl-8" }
const _hoisted_5 = { class: "col-xl-4" }
const _hoisted_6 = { class: "col-xl-4" }
const _hoisted_7 = { class: "col-xl-4 d-none" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MixedWidget1 = _resolveComponent("MixedWidget1")!
  const _component_StatisticsWidget5 = _resolveComponent("StatisticsWidget5")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_MixedWidget1, {
        "widget-classes": "card-xl-stretch mb-xl-8",
        "widget-color": "primary",
        "widget-title": "Resumen de participación",
        "widget-amount": _ctx.total,
        "items-list": _ctx.listRTRegister,
        "items-two": _ctx.listRGender
      }, null, 8, ["widget-amount", "items-list", "items-two"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_StatisticsWidget5, {
            "widget-classes": "card-xl-stretch mb-xl-8",
            "svg-icon": "bi bi-dribbble",
            color: "warning",
            "icon-color": "text-white",
            title: _ctx.sports,
            description: "Deportes"
          }, null, 8, ["title"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_StatisticsWidget5, {
            "widget-classes": "card-xl-stretch mb-xl-8",
            "svg-icon": "bi bi-buildings",
            color: "danger",
            "icon-color": "text-white",
            title: _ctx.clubs,
            description: "Instituciones"
          }, null, 8, ["title"])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_StatisticsWidget5, {
            "widget-classes": "card-xl-stretch mb-xl-8",
            "svg-icon": "media/icons/duotune/finance/fin006.svg",
            color: "info",
            "icon-color": "white",
            title: "$50,000",
            description: "Escenarios"
          })
        ])
      ])
    ])
  ]))
}